import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NavBarService } from '@app/core/components/nav-bar/nav-bar.service';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-favourites-dialog',
    templateUrl: './favourites-dialog.component.html',
    styleUrls: ['./favourites-dialog.component.css'],
})
export class FavouritesDialogComponent {
    public favourites: FavouriteItem[] = [];

    public state;

    public parms;

    public name = '';

    public errorMessage = '';

    public current?: FavouriteItem;

    public filter = '';

    constructor(private dialogRef: MatDialogRef<FavouritesDialogComponent>, private datatask: DataTaskService, public navBar: NavBarService, state: StateService) {
        this.state = state.getCurrentName();
        this.parms = state.getCurrentPath().slice(this.state.length + 2);
        this.loadFavourites();

        this.dialogRef.beforeClosed().subscribe({
            next: async () => {
                const deletes = this.favourites.filter((favourite) => favourite.toDelete === true);

                for (let favourite of deletes) {
                    await this.deleteFavourite(favourite);
                }
            },
        });
    }

    public saving = false;

    public async save() {
        const newName = this.getName();

        if (!newName.trim() || !this.state.trim()) return;

        this.saving = true;

        try {
            const { errormessage, errorcode } = await this.saveNewFavourite(newName, this.state, this.parms);

            if (errorcode !== '0') {
                this.errorMessage = errormessage;
            } else {
                this.loadFavourites();
            }
        } finally {
            this.saving = false;
        }
    }

    public async update() {
        if (!this.current) return;

        const newName = this.getName();

        if (!newName.trim() || !this.state.trim()) return;
        this.saving = true;

        try {
            const { errormessage, errorcode } = await this.updateFavourite({ ...this.current, item_name: newName });

            if (errorcode !== '0') {
                this.errorMessage = errormessage;
            } else {
                this.loadFavourites();
            }
        } finally {
            this.saving = false;
        }
    }

    public setToDelete(item: FavouriteItem, toDelete: boolean) {
        item.toDelete = toDelete;
    }

    private async loadFavourites() {
        this.favourites = await this.datatask.Post(2235);

        const found = this.favourites.find((favourite) => favourite.item_state + favourite.item_parms === this.state + this.parms);

        if (found) {
            this.current = found;
            this.name = this.current.item_name;
        }
    }

    private getName(): string {
        return this.name.trim() > '' ? this.name : this.navBar.getHeading();
    }

    private async saveNewFavourite(name: string, state: string, parms?: string): Promise<ErrorMessageResponse> {
        return this.favouriteCommonUpdate({ myfavorites_keyno: '0', item_name: name, item_state: state, item_parms: parms ?? '', orderby: '0' }, 'NEW');
    }

    private async updateFavourite(favourite: FavouriteItem): Promise<ErrorMessageResponse> {
        return this.favouriteCommonUpdate(favourite, 'UPDATE');
    }

    private deleteFavourite(favourite: FavouriteItem): Promise<ErrorMessageResponse> {
        return this.favouriteCommonUpdate(favourite, 'DELETE');
    }

    private async favouriteCommonUpdate(favourite: FavouriteItem, updateType: 'NEW' | 'UPDATE' | 'DELETE'): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(2236, { ...favourite, function: updateType }))[0];
    }
}

interface FavouriteItem {
    myfavorites_keyno: string;
    item_name: string;
    item_state: string;
    item_parms: string;
    orderby: string;
    toDelete?: boolean;
}
